export const ACTIVE_CHATS_TAB = 'chats';
export const PENDING_CHATS_TAB = 'pending';
export const DASHBOARD_TAB = 'dashboard';
export const SETTINGS_TAB = 'settings';
export const DEPARTMENTS_TAB = 'departments';
export const PHONE_NUMBERS_TAB = 'phoneNumbers';

export const TEMPLATE_REFERENCE_TYPES = [
  { value: 'PROPOSTA', label: 'Proposta (Passivo)' },
  { value: 'PROPOSTA_ATIVO', label: 'Proposta (Ativo)' },
  { value: 'INTERESSE', label: 'Mensagem de Interesse' },
  { value: 'COBRANCA_MINUTA_ENVIO_1', label: 'Cobrança de Minuta' },
  // Único tipo que vários templates podem ter: no detalhe do caso o usuário escolhe
  // qual enviar pelo nome da Meta (AFCO-528).
  { value: 'ENVIO_MANUAL', label: 'Envio manual' },
];

export const SETTINGS_VIEW_ATENDIMENTO = 'atendimento';
export const SETTINGS_VIEW_META_CONFIG = 'meta-config';
export const SETTINGS_VIEW_HEALTH = 'health';
export const SETTINGS_VIEW_TEMPLATE_CONFIG = 'template-config';

// Dados da plataforma que preenchem os parâmetros do template (de-para da tela
// "Configurar template"). O `value` é o código salvo no backend (whatsapp-oficial).
export const TEMPLATE_PARAM_DATA_OPTIONS = [
  { value: 'CLIENT_NAME', label: 'Nome do Cliente' },
  { value: 'COMPANY_NAME', label: 'Nome da Empresa' },
  { value: 'LAWYER_NAME', label: 'Nome do Advogado' },
  { value: 'AUTHOR_NAME', label: 'Nome do Autor' },
  { value: 'RECIPIENT_NAME', label: 'Nome do Destinatário' },
  { value: 'PROCESS_NUMBER', label: 'Nº do Processo' },
  { value: 'PROPOSAL_VALUE', label: 'Valor da proposta' },
  { value: 'MINUTA_LINK', label: 'Link da Minuta' },
];
